enum LegMaterialCreateStepEnum {
  TYP_MATERIALU_1 ='TYP_MATERIALU_1',
  BASIC_DATA_2 ='BASIC_DATA_2',
  RELATED_DATA_3 ='RELATED_DATA_3',
  PREDKLADATEL_4 ='PREDKLADATEL_4',
  CHECK_DATA_5 ='CHECK_DATA_5',
  CREATE_UPDATE_6 ='CREATE_UDATE_6',
}
export default LegMaterialCreateStepEnum;

export const stepValues: Record<LegMaterialCreateStepEnum, number> = {
  [LegMaterialCreateStepEnum.TYP_MATERIALU_1]: 1,
  [LegMaterialCreateStepEnum.BASIC_DATA_2]: 2,
  [LegMaterialCreateStepEnum.RELATED_DATA_3]: 3,
  [LegMaterialCreateStepEnum.PREDKLADATEL_4]: 4,
  [LegMaterialCreateStepEnum.CHECK_DATA_5]: 5,
  [LegMaterialCreateStepEnum.CREATE_UPDATE_6]: 6,
};
